import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_114: DocMigration = {
  maxSchemaVersion: "0.0.114",
  description: "Multiple conditional structural layers for wall assemblies",
  apply(json: any) {
    const { roomLayouts } = json;

    for (const roomLayoutId in roomLayouts) {
      const { wallAssemblies } = roomLayouts[roomLayoutId];

      if (!wallAssemblies) {
        continue;
      }

      for (const { wallAssemblyOverride } of wallAssemblies) {
        if (wallAssemblyOverride.structuralLayerOverride) {
          wallAssemblyOverride.structuralLayerOverrides = [wallAssemblyOverride.structuralLayerOverride];
          delete wallAssemblyOverride.structuralLayerOverride;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_114;
